import React, { useState } from 'react';
import './ContactoPage.css';
import CustomAlert from '../components/CustomAlert';
import useCustomAlert from '../hooks/useCustomAlert';

export default function ContatoPage() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    assunto: '',
    mensagem: ''
  });
  const { alertProps, showSuccess } = useCustomAlert();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Formulário enviado:', formData);
    showSuccess(
      'Mensagem enviada com sucesso! Entraremos em contacto em breve.',
      'Mensagem Enviada'
    );
    setFormData({
      nome: '',
      email: '',
      assunto: '',
      mensagem: ''
    });
  };

  return (
    <div className="contato-page">
      <section className="contato-hero">
        <div className="container">
          <h1 className="contato-title">ENTRE EM CONTATO CONNOSCO</h1>
        </div>
      </section>

      <section className="contact-form-section">
        <div className="contact-container">
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label>Nome *</label>
              <input 
                type="text" 
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                placeholder="Insira seu nome"
                required
              />
            </div>

            <div className="form-group">
              <label>Email *</label>
              <input 
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Insira seu email"
                required
              />
            </div>

            <div className="form-group">
              <label>Assunto</label>
              <input 
                type="text"
                name="assunto"
                value={formData.assunto}
                onChange={handleChange}
                placeholder="Insira o assunto"
              />
            </div>

            <div className="form-group">
              <label>Mensagem</label>
              <textarea 
                name="mensagem"
                value={formData.mensagem}
                onChange={handleChange}
                placeholder="Digite sua mensagem aqui"
                rows="6"
              />
            </div>

            <button type="submit" className="submit-btn">
              Enviar
            </button>
          </form>

          <CustomAlert {...alertProps} />
        </div>
      </section>

      <section className="map-section">
        <div className="map-container-wrapper">
          <div className="map-info">
            <p className="map-title">📍 Barco de Papel</p>
            <p className="map-address">Barco de Papel - Academia de Criatividade</p>
            <p className="map-address">R. 31 janeiro, 12 4490-511 Póvoa de Varzim</p>
            <div className="map-links">
              <a 
                href="https://www.barcodepapel.pt/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="map-link"
              >
                Link
              </a>
              <a 
                href="https://www.google.com/maps/dir//R.+31+janeiro+12+4490-511+Póvoa+de+Varzim" 
                target="_blank" 
                rel="noopener noreferrer"
                className="map-link"
              >
                Direções
              </a>
            </div>
          </div>
          <div className="map-iframe-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3004.8087847477896!2d-8.764893!3d41.383333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd2464e3ed7b0001%3A0x8a7b0d0d0d0d0d0d!2sR.%2031%20de%20Janeiro%2012%2C%204490-511%20P%C3%B3voa%20de%20Varzim!5e0!3m2!1sen!2spt!4v1234567890"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Barco de Papel"
            />
          </div>
        </div>
      </section>

      <section className="contact-info-section">
        <div className="container">
          <div className="info-grid">
            <div className="info-card">
              <h3>📧 Email</h3>
              <p>
                <a href="mailto:academiabarcodepapel@gmail.com">
                  academiabarcodepapel@gmail.com
                </a>
              </p>
            </div>

            <div className="info-card">
              <h3>📱 Telefone</h3>
              <p>
                <a href="tel:936678220">936 678 220</a>
              </p>
            </div>

            <div className="info-card">
              <h3>🕐 Horário</h3>
              <p>Segunda a Sexta: 10h - 18h</p>
              <p>Sábados: Sob marcação</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}